module.exports = __webpack_public_path__ + "static/media/l_dot_10.e8274952.png";